export default {
  routes: [
    {
      name: 'units',
      path: '/directory/units',
      component: () => import('./views/TheUnits.vue'),

    },

    {
      name: 'unit',
      path: '/directory/units/:uuid',
      component: () => import('./views/TheUnit.vue'),
    },
  ]
}
